import React, { useEffect } from 'react';

import Cookies from 'js-cookie';
import { END } from 'redux-saga';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next';
import { useSelector } from 'react-redux';

import {
  IBannerProps,
  INITIAL_STATE_FILTERS,
  IShowCaseState,
  loadShowCaseData,
  resetFilters,
} from 'store/modules/showcase';
import { objectIsEmpty } from 'utils/objectEmpty';
import { IState, SagaStore, storeWrapper } from 'store';

import SEO from 'components/common/SEO';
import Layout from 'components/Layout';
import { Showcase } from 'components/pages/Showcase';
const Banner = dynamic(
  () => import('components/common/Templates/Carousel/Banner'),
);
const Error404 = dynamic(() => import('components/common/Error404'));

import * as S from 'styles/pages/App/Showcase';

interface IShowcase {
  permaLink: string;
  bannersSSR: Array<IBannerProps>;
}

export default function ShowcaseBrand({ permaLink, bannersSSR }: IShowcase) {
  const router = useRouter();
  const { showcase, banners } = useSelector<IState, IShowCaseState>(
    state => state.showcase,
  );

  useEffect(() => {
    if (!router.query?.campanha) {
      Cookies.remove('@SportsNutrition:campanha');
    }
  }, [router]);

  if (objectIsEmpty(showcase)) {
    return (
      <Layout>
        <SEO />
        <Error404 />
      </Layout>
    );
  }

  return (
    <Layout>
      <SEO
        title={showcase.titulo}
        description={showcase.seo_Descricao}
        keywords={showcase.seo_PalavrasChaves}
      >
        <meta name="cs:page" content="categorias" />
      </SEO>

      <S.Container>
        <Banner banners={banners.length ? banners : bannersSSR} />
        <Showcase permaLink={permaLink} />
      </S.Container>
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps =
  storeWrapper.getServerSideProps(async ({ params, store, res }) => {
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=600, stale-while-revalidate=600',
    );

    const { slug } = params;

    store.dispatch(resetFilters());

    store.dispatch(
      loadShowCaseData({
        permaLink: `vitrine/marca/${slug}`,
        routeParams: { ...INITIAL_STATE_FILTERS },
      }),
    );
    store.dispatch(END);

    await (store as SagaStore).sagaTask.toPromise();

    return {
      props: {
        permaLink: `vitrine/marca/${slug}`,
      },
    };
  });
